import sapiConfig from "../configs/sapi";
import { httpMStepsClient } from "./utils/httpService";

const BASE_URL = sapiConfig.api.domain;
const Controller = "/intouch";

export interface IntouchPreviewRow {
  orderNumber: string;
  partCode: string;
  description: string;
  orderQuantity: number;
  material: string;
  machineCode: string;
  machineId: string | null;
  toolCode: string;
  standardCycleTime: number;
  impressions: number;
  issue: string | null;
  intouchStatus: string | null;
  intouchMachineName: string | null;
}

export interface IntouchScheduleJob {
  jobId: string;
  orderNumber: string;
  status: number;
  statusLabel: string;
  partCode: string;
  description: string;
  orderQuantity: number;
  alreadyMade: number;
  made: number | null;
  percentDone: string | null;
  material: string;
  impressions: number;
  toolCode: string;
  standardCycleTime: number;
  plannedStart: string | null;
  dueDate: string | null;
  startTime: string | null;
  endTime: string | null;
}

export interface IntouchScheduleRow {
  machineId: string;
  machineName: string;
  machineDescription: string;
  runningCount: number;
  scheduledCount: number;
  finishedCount: number;
  totalJobs: number;
  jobs: Array<IntouchScheduleJob>;
}

export const getIntouchSchedule = async () => {
  return await httpMStepsClient({
    baseURL: BASE_URL,
    type: "GET",
    path: `${Controller}/schedule`,
  });
};

export interface IntouchMachine {
  machineId: string;
  machineName: string;
  machineDescription: string;
  active: boolean;
}

export const getIntouchMachines = async () => {
  return await httpMStepsClient({
    baseURL: BASE_URL,
    type: "GET",
    path: `${Controller}/machines`,
  });
};

export const getIntouchFinishedJobs = async (filters: {
  machineIds: Array<string>;
  startDate: string;
  endDate: string;
}) => {
  const query = new URLSearchParams({
    startDate: filters.startDate,
    endDate: filters.endDate,
  });
  if (filters.machineIds.length > 0) {
    query.append("machineIds", filters.machineIds.join(","));
  }
  return await httpMStepsClient({
    baseURL: BASE_URL,
    type: "GET",
    path: `${Controller}/finished-jobs?${query.toString()}`,
  });
};

export const previewIntouchImport = async () => {
  return await httpMStepsClient({
    baseURL: BASE_URL,
    type: "GET",
    path: `${Controller}/preview`,
  });
};

export const confirmIntouchImport = async (rows: Array<IntouchPreviewRow>) => {
  return await httpMStepsClient({
    baseURL: BASE_URL,
    type: "POST",
    path: `${Controller}/import`,
    body: { rows },
  });
};
